const DOCTORAL_CREDENTIALS = new Set(['DDS', 'DMD']);

export const shouldShowDoctorTitle = (credentials?: string | null): boolean =>
  !!credentials && DOCTORAL_CREDENTIALS.has(credentials.trim().toUpperCase());
